export default class Messages {
    private static listeners: { [key: string]: ((data: any) => Promise<void> | void)[] } = {};

    public static send(channel: string, data: any) {
        if (this.listeners[channel]) {
            setTimeout(() => this.listeners[channel].map(callback => callback(data)), 100);
        }
    }

    public static listen(channel: string, callback: (data: any) => Promise<void> | void) {
        if (!this.listeners[channel]) {
            this.listeners[channel] = [];
        }
        this.listeners[channel].push(callback);
    }
}



// WEBPACK FOOTER //
// ./src/utilities/Messages.ts